// eslint-disable-next-line no-restricted-imports
import Lottie from 'lottie-react'

/**
 * @todo THIS NEEDS TO BE LAZY-LOADED
 */

export default Lottie
